// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"438":"Login","596":"404","623":"Banner"}[chunkId] || chunkId) + "." + {"438":"1f18992c","596":"ce8b9751","623":"a8217d2a","748":"2385f801"}[chunkId] + ".css";
};